<template>
  <RoleDrawer ref="drawerComponentRole" v-model="drawer" @role-updated="callApi" v-model:editUser="editUser" />
  <v-container>
    <div class="exploration-table fd-table fd-settings-roles-table">
      <div class="table-top-content">
        <div class="d-flex align-center">
          <div class="title">Roles &amp; Permission<span class="userCount">{{ filteredRoles.length }} roles</span></div>
        </div>
        <div class="fd-settings-toolbar">
          <div class="search-container">
            <v-text-field
              ref="rolesSearch"
              v-model="searchQuery"
              placeholder="Search"
              variant="outlined"
              density="compact"
              clearable
              hide-details
              class="search-input"
            >
              <template #prepend-inner>
                <img :src="searchIcon" alt="" width="16" height="16" class="fd-action-icon" />
              </template>
            </v-text-field>
          </div>
          <div class="test-pdf-div">
            <v-btn class="pdf-btn add-role-btn" @click="openSideModal">
              <span><img :src="addIcon" alt="" width="16" height="16" class="fd-action-icon" /> Add Role</span>
            </v-btn>
          </div>
        </div>
      </div>
      <!-- Add a scrollable wrapper around the table -->
      <div class="table-scroll-wrapper">
        <TabularLoaders v-if="loading" :columns="3" :rows="8" row-variant="user" />
        <v-data-table-server
          v-else
          v-model:items-per-page="itemsPerPage"
          :headers="headers"
          :items="paginatedRoles"
          :items-per-page-options="pageOptions"
          :items-length="filteredRoles.length"
          :loading="false"
          item-value="name"
          hide-default-footer
          @update:options="handlePageChange"
          fixed-header
          :height="tableScrollHeight"
        >
          <template v-slot:headers>
            <tr>
              <th v-for="header in headers" :key="header.key" class="text-left header-cell">
                <div class="d-flex align-center">
                  <div class="sort-icon-title d-flex align-center fd-settings-sort-title">
                    {{ header.title }}
                  </div>
                </div>
              </th>
            </tr>
          </template>
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <div class="user-info">
                  <div class="d-flex align-center">
                    <span class="item-name">{{ item.name }}</span>
                    <!-- <v-chip  class="status-chip" color="#ABEFC6"
                      text-color="#067647" size="small">
                      Active
                    </v-chip> -->
                  </div>
                  <span class="item-description">{{ item.description }}</span>
                </div>
              </td>
              <td class="fd-settings-chip-cell">
                <div class="fd-settings-chip-wrap">
                  <span
                    v-for="permission in item.permissions"
                    :key="permission"
                    class="fd-settings-chip"
                    :class="roleChipClass(permission)"
                  >
                    {{ permission }}
                  </span>
                </div>
              </td>
              <td class="fd-settings-actions-cell">
                <div class="fd-settings-row-actions">
                  <button type="button" class="fd-settings-action-btn" @click="editUserModal(item)">
                    <img :src="pencil" alt="Edit" />
                  </button>
                  <button type="button" class="fd-settings-action-btn fd-settings-action-btn--delete" @click="showDeleteConfirmation(item)">
                    <img :src="delete_icon" alt="Delete" />
                  </button>
                </div>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <div class="d-flex justify-center align-center pa-4">
              No data available
            </div>
          </template>
        </v-data-table-server>
      </div>
      <Pagination
        v-if="!loading && filteredRoles.length > 0"
        variant="scorecard"
        :total-items="filteredRoles.length"
        v-model:current-page="page"
        v-model:items-per-page="itemsPerPage"
        item-label="Roles"
        :page-sizes="pageOptions"
      />
    </div>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :timeout="snackbar.timeout">
      {{ snackbar.message }}
    </v-snackbar>
    
    <!-- Delete Confirmation Modal -->
    <v-dialog transition="dialog-top-transition" v-model="confirmDeleteDialog" width="417">
      <div class="cross-btn-div" @click="closeDeleteConfirmation">
        <img :src="close_icon" alt="close" width="20" height="20" class="fd-action-icon" />
      </div>
      <v-alert title="Delete Role" :text="confirmDeleteText">
        <template #prepend>
          <div class="fd-delete-modal-icon">
            <img :src="delete_icon" alt="" width="24" height="24" class="fd-action-icon" />
          </div>
        </template>
        <div class="alert-btns-div">
          <v-btn class="cancel-btn" flat @click="closeDeleteConfirmation">Cancel</v-btn>
          <v-btn class="delete-btn" flat @click="confirmDeleteRole" :loading="deleteLoading">
            Delete</v-btn>
        </div>
      </v-alert>
    </v-dialog>
  </v-container>
</template>

<script>
import api from "../../axiosInterceptor";
import axios from "axios";
import RoleDrawer from "@/components/Roles/RoleDrawer.vue";
import Pagination from "@/components/layout/Common/Pagination.vue";
import TabularLoaders from "@/components/layout/Loaders/TabularLoaders.vue";
export default {
  name: "TableData",
  components: {
    RoleDrawer,
    Pagination,
    TabularLoaders,
  },
  props: {
    roles: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sort_up: require("../../assets/Svg/Table/up.svg"),
      sort_down: require("../../assets/Svg/Table/down.svg"),
      reset_icon: require("../../assets/Svg/Icons/reset.svg"),
      searchIcon: require("../../assets/Svg/Icons/search.svg"),
      addIcon: require("../../assets/Svg/Icons/add.svg"),
      close_icon: require("../../assets/Svg/Icons/cross.svg"),
      elipse: require("../../assets/Svg/elipse.svg"),
      pencil: require("../../assets/Svg/Icons/edit-2.svg"),
      delete_icon: require("../../assets/Svg/trash.svg"),
      itemsPerPage: Number(localStorage.getItem('itemsPerPage')) || 20,
      headers: [
        { title: 'Role', key: 'role', sortable: false },
        { title: 'Permissions', key: 'permission', sortable: false },
        { title: 'Actions', key: 'action', sortable: false }
      ],
      totalItems: 0,
      page: 1,
      pageOptions: [20, 50, 100, 200, 300, 400, 500],
      searchQuery: '',
      searchLoading: false,
      loadingCsv: false,
      drawer: false,
      user: {
        name: '',
        email: '',
        role: '',
      },
      snackbar: {
        visible: false,
        message: "",
        color: "success",
        timeout: 3000,
      },
      editUser: "",
      confirmDeleteDialog: false,
      confirmDeleteText: "",
      deleteLoading: false,
      selectedRole: null
    };
  },
  computed: {
    tableScrollHeight() {
      return "100%";
    },
    serverItems() {
      return this.roles; // Directly mapping props to computed property
    },
    filteredRoles() {
      if (!this.searchQuery) {
        return this.roles;
      }
      
      const query = this.searchQuery.toLowerCase();
      return this.roles.filter(role => {
        const nameMatch = role.name && role.name.toLowerCase().includes(query);
        
        const descriptionMatch = role.description && role.description.toLowerCase().includes(query);
        
        const permissionsMatch = role.permissions && role.permissions.some(permission => 
          permission.toLowerCase().includes(query)
        );
        
        return nameMatch || descriptionMatch || permissionsMatch;
      });
    },
    paginatedRoles() {
      const perPage = Number(this.itemsPerPage) || 20;
      const start = (this.page - 1) * perPage;
      return this.filteredRoles.slice(start, start + perPage);
    }
  },
  methods: {
    roleChipClass(role) {
      const key = String(role || "").toLowerCase();
      if (key.includes("admin")) return "fd-settings-chip--admin";
      if (key.includes("manager")) return "fd-settings-chip--manager";
      if (key.includes("viewer")) return "fd-settings-chip--viewer";
      return "";
    },
    callApi() {
      this.$emit("roles-api-call");
    },
    showSnackbar(message, color = "success") {
      this.snackbar.message = message;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },
    openSideModal() {
      this.$refs.drawerComponentRole.resetForm();
      this.editUser = null;
      this.drawer = true;
    },
    editUserModal(item) {
      this.editUser = item
      this.drawer = true;
    },
    handlePageChange({ page, itemsPerPage }) {
      this.$emit('update:pagination', { page, itemsPerPage });
      localStorage.setItem('itemsPerPage', itemsPerPage);
    },
    showDeleteConfirmation(item) {
      this.selectedRole = item;
      this.confirmDeleteText = `Are you sure you want to delete the role "${item.name}"? This action cannot be undone.`;
      this.confirmDeleteDialog = true;
    },
    closeDeleteConfirmation() {
      this.confirmDeleteDialog = false;
      this.selectedRole = null;
      this.deleteLoading = false;
    },
    async confirmDeleteRole() {
      if (!this.selectedRole) return;
      
      this.deleteLoading = true;
      const roleId = this.selectedRole.id;

      try {
        const response = await api.delete(`${process.env.VUE_APP_API_URL}public/api/admin/roles/${roleId}`);

        if (response && response.data) {
          if (response.data.statusCode === 200 || response.data.statusCode === 201) {
            this.showSnackbar(response.data.message || "Role deleted successfully!", "success");
            this.$emit("roles-api-call");
            this.closeDeleteConfirmation();
          } else {
            this.showSnackbar(response.data.message || "Error deleting role", "error");
          }
        } else {
          this.showSnackbar("Unexpected response from server", "error");
        }
      } catch (error) {
        this.showSnackbar(error.response?.data?.message || "Error deleting role", "error");
      } finally {
        this.deleteLoading = false;
      }
    }

  },
  watch: {
    roles: {
      handler(newVal) {
        this.totalItems = newVal.length; // Update total items count
      },
      immediate: true,
      deep: true
    },
    searchQuery() {
      this.page = 1;
    },
    itemsPerPage() {
      this.page = 1;
    }
  }
};
</script>
